<template>
  <div class="validate-panel" v-if="showValidate">
    <!-- 点击式按钮建议高度介于36px与46px  -->
    <div id="VAPTCHAContainer" style="width: 300px;height: 36px;    top: 50%;
    left: 50%;
    position: fixed;
    transform: translate(-50%,-50%);" ref="vpContainer">
      <!-- 下面代码为预加载动画代码，仅供参考 -->
      <div class="VAPTCHA-init-main">
        <div class="VAPTCHA-init-loading">
          <a href="/" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48px"
                 height="60px" viewBox="0 0 24 30"
                 style="enable-background: new 0 0 50 50; width: 14px; height: 14px; vertical-align: middle"
                 xml:space="preserve">
                        <rect x="0" y="9.22656" width="4" height="12.5469" fill="#CCCCCC">
                            <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s"
                                     repeatCount="indefinite"></animate>
                          <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s"
                                   repeatCount="indefinite"></animate>
                        </rect>
              <rect x="10" y="5.22656" width="4" height="20.5469" fill="#CCCCCC">
                            <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s"
                                     repeatCount="indefinite"></animate>
                <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s"
                         repeatCount="indefinite"></animate>
                        </rect>
              <rect x="20" y="8.77344" width="4" height="13.4531" fill="#CCCCCC">
                            <animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s"
                                     repeatCount="indefinite"></animate>
                <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s"
                         repeatCount="indefinite"></animate>
                        </rect>
                    </svg>
          </a>
          <span class="VAPTCHA-text">Vaptcha Initializing...</span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import global from "../../config/global";
  import {doLoginAsVisitorWithTK} from "../../api/home-api";
  import {validate} from "../../utils/tools";

  export default {
    name: "validate4new",
    props: {
      showValidate: {
        type: Boolean,
        default: false
      },
      sucCallback: {
        type: Function,
        default: null
      },
      failedCallback: {
        type: Function,
        default: null
      }
    },
    watch: {
      showValidate(n, o) {
        if (n) {
          let target = this;
          this.$nextTick(() => {
            var config = {
              vid: global.vk,
              mode: 'click',
              scene: 0,
              container: this.$refs.vpContainer,
              style: 'light',
              color: '#00BFFF',
              lang: 'auto',
              area: 'auto',
            };
            this.loadV3Script().then(() => {
              window.vaptcha(config).then((obj) => {
                // vue3需要将obj存储到vue外部，例如window对象
                window.vaptchaObj = obj;

                obj.listen('pass', function () {
                  // this.token = obj.getToken();
                  validate(null, null, false)
                  let token = obj.getToken()
                  doLoginAsVisitorWithTK(token, function (data, page) {
                    target.sucCallback && target.sucCallback(data, page)
                  }, function (code, msg, page) {
                    target.failCallback && target.failCallback(code, msg, page)
                  }, global.application)
                });
                obj.listen('close', function () {
                  obj.reset();
                });

                obj.render();
              });
            });
          })

        }
      }
    },
    methods: {
      // 请勿将v3编译进vue项目中
      loadV3Script() {
        if (typeof window.vaptcha === 'function') {
          //如果已经加载就直接放回
          return Promise.resolve();
        } else {
          return new Promise((resolve) => {
            var script = document.createElement('script');
            script.src = 'https://v.vaptcha.com/v3.js';
            script.async = true;
            script.onload = script.onreadystatechange = function () {
              if (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete') {
                resolve();
                script.onload = script.onreadystatechange = null;
              }
            };
            document.getElementsByTagName('head')[0].appendChild(script);
          });
        }
      },
      getToken() {
        let serverToken = window.vaptchaObj.getServerToken();
        return serverToken;
      },
      reset() {
        window.vaptchaObj.reset();
      },
    },
  }
</script>

<style scoped>

  .VAPTCHA-init-main {
    display: table;
    width: 100%;
    height: 100%;
    background-color: #eeeeee;
  }

  .VAPTCHA-init-loading {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }

  .VAPTCHA-init-loading > a {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: none;
  }

  .VAPTCHA-init-loading .VAPTCHA-text {
    font-family: sans-serif;
    font-size: 12px;
    color: #cccccc;
    vertical-align: middle;
  }

  .validate-panel {
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .7);
  }
</style>



// WEBPACK FOOTER //
// src/components/widget/validate4new.vue